module.exports = __webpack_public_path__ + "static/8i-1d727abb1018c5cc6331c1e26169d590.woff";